import React, { useState } from "react";
import { requestAccount } from "../../api/requestaccount";


export default function RequestAccount() {
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm: "" });
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const isPasswordValid = (pwd) =>
  pwd.length >= 8 &&
  /[A-Z]/.test(pwd) &&
  /[a-z]/.test(pwd) &&
  /[0-9]/.test(pwd) &&
  /[!@#$%^&*(),.?":{}|<>]/.test(pwd);


  const handleSubmit = async (e) => {
  e.preventDefault();
  setMsg("");
  setErr("");
  if (form.password !== form.confirm)
    return setErr("Passwords do not match");

  try {
      await requestAccount({
      name: form.name,
      email: form.email,
      password: form.password,
    });

    // Redirect to verify page after signup succeeds
    setMsg("Verification code sent. Please verify your email.");
    setTimeout(() => {
    window.location.href = `/verify?email=${encodeURIComponent(form.email)}`;
  }, 1500);

  } catch (err) {
    setErr(err.message);
  }
};


  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8">
        <div className="text-center mb-6">
          <img
            src="infauxtech_logo_rectangle.png"
            alt="Media Forensics Hub"
            className="w-32 mx-auto mb-4"
          />
          <h2 className="text-2xl font-bold text-purple-800">Request an Account</h2>
          <p className="text-gray-600 mt-1 text-sm">
            Fill in the details below to request access.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-left text-gray-700 font-medium mb-1">Name</label>
            <input
              name="name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none"
              required
            />
          </div>

          <div>
            <label className="block text-left text-gray-700 font-medium mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none"
              required
            />
          </div>

           {/* Password Fields */}
          <div>
            <label className="block text-left text-gray-700 font-medium mb-1">
              Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none"
              required
              autoComplete="new-password"
            />

            {/* Password Requirements */}
            <ul className="mt-2 text-xs text-gray-600 space-y-1">
              <li className={form.password.length >= 8 ? "text-green-600" : "text-gray-500"}>
                • At least 8 characters
              </li>
              <li className={/[A-Z]/.test(form.password) ? "text-green-600" : "text-gray-500"}>
                • One uppercase letter (A–Z)
              </li>
              <li className={/[a-z]/.test(form.password) ? "text-green-600" : "text-gray-500"}>
                • One lowercase letter (a–z)
              </li>
              <li className={/[0-9]/.test(form.password) ? "text-green-600" : "text-gray-500"}>
                • One number (0–9)
              </li>
              <li className={/[!@#$%^&*(),.?":{}|<>]/.test(form.password) ? "text-green-600" : "text-gray-500"}>
                • One special character (!@#$%^&*)
              </li>
            </ul>
          </div>

          <div>
            <label className="block text-left text-gray-700 font-medium mb-1">
              Confirm Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              name="confirm"
              value={form.confirm}
              onChange={(e) => setForm({ ...form, confirm: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none"
              required
            />
          </div>

          {/* Checkbox to toggle visibility */}
          <div className="flex items-center space-x-2 mt-2">
            <input
              type="checkbox"
              id="showPassword"
              checked={showPassword}
              onChange={() => setShowPassword(!showPassword)}
              className="h-4 w-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
            />
            <label htmlFor="showPassword" className="text-gray-700 text-sm">
              Show Passwords
            </label>
          </div>


          <button
            type="submit"
            disabled={!isPasswordValid(form.password)}
            className="w-full bg-purple-700 text-white font-semibold py-2 rounded-lg hover:bg-purple-800 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Request Account
          </button>

        </form>

        {msg && (
          <p className="mt-4 text-green-600 text-center font-medium">{msg}</p>
        )}
        {err && (
          <p className="mt-4 text-red-600 text-center font-medium">{err}</p>
        )}

        <p className="mt-6 text-gray-600 text-center text-sm">
          Already have an account?{" "}
          <a
            href="/login"
            className="text-purple-700 font-semibold hover:underline"
          >
            Sign in
          </a>
        </p>
      </div>
    </div>
  );
}
